<fc-general-filter-modal [baseId]="baseId" [form]="form" [fcFilterModalContext]="fcFilterModalContext" (apply)="save()"
    (cancel)="onCancel()" (clear)="onClear()" [disableClear]="disableClear">
    <div [formGroup]="form">
        <mat-tab-group animationDuration="0ms" mat-align-tabs="start" class="tabs-default" [disableRipple]="true"
            (selectedTabChange)="tabChanged($event)">
            <mat-tab>
                <ng-template mat-tab-label>
                    <span class="tab-label" translate>Filters</span>
                </ng-template>

                <div class="emds-row">
                    <div class="form-group">
                        <label [for]="baseId + '-name'" translate>Drug</label>
                        <input [id]="baseId + '-name'" class="form-control" type="text" formControlName="drug" />
                    </div>

                    <div class="form-group">
                        <div class="checkbox-btn-group">
                            <div class="checkbox-group">
                                <mat-checkbox *ngFor="let checkbox of checkBoxControlsList"
                                    [checked]="form.get(checkbox.controlName)?.value === 'true'"
                                    (change)="form.get(checkbox.controlName)?.setValue($event.checked ? 'true' : 'false')">
                                    {{ checkbox.label }}
                                </mat-checkbox>
                            </div>
                        </div>
                    </div>
                </div>
            </mat-tab>
        </mat-tab-group>
    </div>
</fc-general-filter-modal>